export default __webpack_public_path__ + "static/pg_green-2d84c68d82266aaac6e31b3fe9ed24d6.png";